const oidc = {
    logout_success: '正常にログアウトしました。',
};
export default Object.freeze(oidc);
